(function () {
  'use strict';

  var defaultLengths = ['Short', 'Medium', 'Long'];

  function inquiryButtons(root) {
    var buttons = [];
    if (!root || root.nodeType !== 1 && root !== document) return buttons;

    if (root.matches && root.matches('[data-inquiry-add]')) buttons.push(root);
    if (root.querySelectorAll) {
      buttons = buttons.concat(Array.prototype.slice.call(root.querySelectorAll('[data-inquiry-add]')));
    }

    return buttons;
  }

  function hydrate(root) {
    inquiryButtons(root || document).forEach(function (button) {
      if (!button.dataset.productLengths) {
        button.dataset.productLengths = JSON.stringify(defaultLengths);
      }

      var card = button.closest('.card-wrapper--inquiry-card');
      var media = card ? card.querySelector('.card__media') : null;
      if (!media || media.querySelector('.card__nail-lengths')) return;

      var overlay = document.createElement('div');
      overlay.className = 'card__nail-lengths';
      overlay.setAttribute('aria-label', 'Available nail lengths');
      overlay.innerHTML =
        '<span class="card__nail-lengths-label">Length:</span>' +
        '<span class="card__nail-lengths-values">' + defaultLengths.join(' / ') + '</span>';
      media.appendChild(overlay);
    });
  }

  function init() {
    hydrate(document);

    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) hydrate(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
